export { default } from './ScbSlip'



// WEBPACK FOOTER //
// ./src/App/components/PaymentBlocks/ScbSlip/index.js